import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalVariables } from '../../../../global-variables';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  private url = GlobalVariables.appURL;

  constructor(private _httpClient: HttpClient) { }

  public login(data: any): any {
    return this._httpClient.post(this.url + 'users/login', data);
  }

  public forgetPassword(data: any): any {
    return this._httpClient.post(this.url + 'users/forgot-password', data);
  }

  public resetPassword(data: any): any {
    return this._httpClient.post(this.url + 'users/reset-password', data);
  }

  public register(data: any): any {
    return this._httpClient.post(this.url + 'users/signup', data);
  }

  public bussiness_register(id: any, userId: any, data: any): any {
    return this._httpClient.patch(this.url + 'business/user/' + userId + '/stores/' + id + '/approve', data);
  }

  public bussiness_approve(id: any): any {
    return this._httpClient.patch(this.url + 'business/stores/' + id + '/approve', {});
  }

  public stote_campaign_approve(id: any): any {
    return this._httpClient.patch(this.url + 'campaignstores/' + id + '/approve', {});
  }

  public business_user_approve(id: any): any {
    return this._httpClient.patch(this.url + 'businessuser/storesuser/' + id + '/accept', {});
  }

  public registration_approve(id: any, businessId: any, data: any): any {
    return this._httpClient.patch(this.url + 'registration_approve/' + id + '/' + businessId, data);
  }

  public business_registration(data: any): any {
    return this._httpClient.post(this.url + 'business_registration', data);
  }

  public partner_registration(businessId: any, data: any): any {
    return this._httpClient.patch(this.url + 'partner_registration/' + businessId, data);
  }

  public send_otp(type: any, userId: any): any {
    return this._httpClient.post(this.url + 'user/' + type + '/send_otp/' + userId, {});
  }

  public validate_otp(userId: any, otp: any): any {
    return this._httpClient.post(this.url + 'user/registration/validate_otp/' + userId + '/' + otp, {});
  }

  public businesss_store_registration(businessId: any, data: any): any {
    return this._httpClient.post(`${this.url}/business/${businessId}/register/stores`, data);
  }
}

